import { Component, Vue } from 'vue-property-decorator'
import LinkItem from '~/types/LinkItem'
import loc from '~/utils/loc'
import Review from '~/components/block/Review'
import NoReviews from '~/components/block/NoReviews'
import s from '~/utils/s'
import SectionHelper from '~/utils/sectionHelper'
import ReviewsSidebar from '~/components/page/reviews/ReviewsSidebar'
import Pagination from '~/components/element/Pagination'
import HeaderType from '~/types/enum/HeaderType'
import PageHeader from '~/components/page/PageHeader'
import { SfSection } from '~/types/api/SfSection'
import mainBreadcrumbsSubmenuItems from '~/utils/mainBreadcrumbsSubmenuItems'

@Component
export default class ReviewsPage extends Vue {
  get breadcrumb (): LinkItem[] {
    const helper = new SectionHelper(s(this.$store).general.sections, this.$store)
    const breadcrumb = s(this.$store).productPage.pathSections.map((e: SfSection) => ({
      title: e.name,
      location: helper.getSectionPathById(e.id) ?? 'catalog'
    }))
    const list = [
      {
        title: 'Главная',
        location: loc(this.$store, { name: 'index' }),
        submenuItems: mainBreadcrumbsSubmenuItems(this.$store)
      },
      ...breadcrumb
    ]

    const { sectionId, id } = s(this.$store).productPage

    list.push({
      title: s(this.$store).productPage.title,
      location: helper.getProductLink(sectionId?.length ? sectionId[0] : s(this.$store).categoryPage.category.id, id) // TODO: добавить seoUrl
    })
    s(this.$store).seo.setCanonical(String(list[list.length - 1].location))
    return list
  }

  renderReviewList () {
    const { reviews } = s(this.$store).reviewsPage
    return (
      <div class="reviews-page__list">
        {reviews.items.map(review => <Review {...{ props: { review } }} />)}
      </div>
    )
  }

  renderContent () {
    const { reviews, page, limit } = s(this.$store).reviewsPage
    const { rating } = s(this.$store).productPage
    const userReviews = s(this.$store).productPage.reviews.filter(review => review.userId === s(this.$store).auth.user?.id)

    return (
      <div class="reviews-page__row">
        <div class="reviews-page__col-list">
          { reviews.items.length
            ? this.renderReviewList()
            : <NoReviews />
          }

          <Pagination {...{
            props: {
              loadMoreMethod: () => s(this.$store).reviewsPage.enableLoadMore(true),
              perPage: limit,
              currentPage: page,
              total: reviews.count
            }
          }} />
        </div>
        <div class="reviews-page__col-sidebar">
          <ReviewsSidebar {...{
            props: {
              userReview: userReviews[0],
              rating
            }
          }} />
        </div>
      </div>
    )
  }

  render () {
    return (
      <div class="reviews-page">
        <div class="reviews-page__header">
          <PageHeader props={{
            typeHeader: HeaderType.Reviews,
            breadcrumb: this.breadcrumb
          }} />
        </div>
        <div class="reviews-page__container">
          {this.renderContent()}
        </div>
      </div>
    )
  }
}
